<template>
  <div>
    <span v-if="loading">
      Loading…
    </span>

    <span v-else-if="error">
      Failed to load content.
    </span>

    <span
      v-else
      v-html="htmlRaw"
    ></span>
  </div>
</template>

<script>
import Api from '@/apis/Api.js';

export default {
  name: "HtmlContent",

  props: {
    slug: { type: String, required: true }
  },

  data() {
    return {
      htmlRaw: "",
      loading: true,
      error: false
    };
  },

  mounted() {
    this.loadContent();
  },

  methods: {
    async loadContent() {
      Api.get(`/content/${this.slug}`, { responseType: "text" })
        .then(res => this.htmlRaw = res.data)
        .catch(() => this.error = true)
        .finally(() => this.loading = false);
    }
  }
};
</script>
